import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const APIURL = process.env.REACT_APP_API_URL;

/**
 * Fires on every login. Idempotent server-side.
 * Passes first/last name from Auth0 so the backend can auto-match a player record.
 * Display name in user_profiles is always "First Last".
 */
export function useUserRegistration() {
  const { isAuthenticated, isLoading, user, getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    if (isLoading || !isAuthenticated || !user) return;

    async function register() {
      try {
        const token = await getAccessTokenSilently();

        // Auth0 may provide given_name/family_name, or we parse from name/nickname
        const firstName = user!.given_name || user!.name?.split(' ')[0] || '';
        const lastName  = user!.family_name || user!.name?.split(' ').slice(1).join(' ') || '';

        await fetch(`${APIURL}/users/register`, {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify({
            username:   user!.nickname || user!.email?.split('@')[0],
            email:      user!.email,
            first_name: firstName,
            last_name:  lastName,
          }),
        });
      } catch {
        // Non-fatal — failures are logged server-side
      }
    }

    register();
  }, [isAuthenticated, isLoading, user]);
}
